import { Check } from "lucide-react";
import { useWizardContext } from "./shared";
import { Button } from "@/components/ui/button";

export function SuccessScreen() {
  const { state, dispatch } = useWizardContext();
  const p = state.payload!;

  return (
    <div className="text-center">
      <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-green-100 text-green-600">
        <Check className="h-9 w-9" strokeWidth={2.5} />
      </div>
      <h1 className="screen-h1">All set, see you soon!</h1>
      <p className="screen-p mt-3">
        Pre-registration complete. When you arrive at <strong>{p.property.name}</strong>, our reception
        team will hand over your key — no paperwork required.
      </p>

      <Button className="mt-8 w-full h-11" onClick={() => dispatch({ type: "goto", step: "arrival" })}>
        View arrival info
      </Button>
    </div>
  );
}
